import _ from 'lodash';
import { defineMessage } from 'react-intl';

import { getCountry } from '../../../../iwIntlProvider/CountryProvider';

const enterAnnualProfit = defineMessage({
    id: '_.your_company.error.enter_annual_profit',
    defaultMessage: 'Please enter your annual profit'
});

const enterAnnualTurnover = defineMessage({
    id: '_.your_company.error.enter_annual_turnover',
    defaultMessage: 'Please enter your annual turnover'
});

const enterTradingFrom = defineMessage({
    id: '_.your_company.error.enter_trading_from',
    defaultMessage: 'Please enter the date you began trading'
});

// eslint-disable-next-line import/no-default-export
export default (values) => {
    let errors = {};

    if (getCountry() === 'UK' && !values.annualProfit) {
        errors = _.setWith(errors, 'annualProfit', enterAnnualProfit);
    }

    if (!values.annualTurnover) {
        errors = _.setWith(errors, 'annualTurnover', enterAnnualTurnover);
    }

    if (!values?.tradingFrom?.day) {
        errors = _.setWith(errors, 'tradingFrom.day', enterTradingFrom);
    }

    if (!values?.tradingFrom?.month) {
        errors = _.setWith(errors, 'tradingFrom.month', enterTradingFrom);
    }

    if (!values?.tradingFrom?.year) {
        errors = _.setWith(errors, 'tradingFrom.year', enterTradingFrom);
    }

    return errors;
};
